<style  scoped>
.tabs:not(:last-child) {
    margin-bottom: 0rem;
}
.tabs {
    -webkit-overflow-scrolling: touch;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    font-size: 1rem;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    /*overflow: hidden;
    overflow-x: auto;*/
    white-space: nowrap;
}
.tabs ul {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-bottom: 1px solid #dbdbdb;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
}
.tabs li {
    display: block;
}
.tabs li.is-active a {
    border-bottom-color: #132148;
    color: #132148;
    opacity: 1
}
.tabs a {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-bottom: 1px solid #dbdbdb;
    color: #4a4a4a;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin-bottom: -1px;
  /*  padding: .5em 1em;*/
  padding: .1em 1em;
    vertical-align: top;
    opacity: 0.5
}
.rightNav2 li {
  display: inline;
  padding-right: 6px;
  padding-left: 20px;
  color: white;
}

.rightNav2 .homeLnk {
    background-image: url('/static/HeadImages/leftmarine-sign-brandcolorop75.png');
    background-repeat: no-repeat;
    background-size: contain;
}

.tabs .homeLnk.is-active
{
    background-image: url('/static/HeadImages/leftmarine-sign-brandcolor.png');
    background-repeat: no-repeat;
    background-size: contain;
}
@media screen and (max-width: 1440px)
{
  .tabs
  {
      display: block;
      font-size: 0.87rem;
      white-space: pre-wrap;
  }
  .tabs ul
  {
    padding: 0px;
    margin: 0px;
  }
  .rightNav2 .homeLnk {
      background-image: url('/static/HeadImages/leftmarine-sign-brandcolorop75.png');
      background-repeat: no-repeat;
      background-size: auto;
  }
  .tabs .homeLnk.is-active
  {
      background-image: url('/static/HeadImages/leftmarine-sign-brandcolor.png');
      background-repeat: no-repeat;
      background-size: auto;
  }
}
@media screen and (max-width: 1280px)
{
  .tabs
  {
      display: block;

      white-space: pre-wrap;
  }
  .tabs ul
  {
    padding: 0px;
    margin: 0px;
  }
  .rightNav2 .homeLnk {
      background-image: url('/static/HeadImages/leftmarine-sign-brandcolorop75.png');
      background-repeat: no-repeat;
      background-size: auto;
  }
  .rightNav2 li {
    display: inline;
    padding-right: 6px;
    padding-left: 20px;
    color: white;
  }
  .tabs .homeLnk.is-active
  {
      background-image: url('/static/HeadImages/leftmarine-sign-brandcolor.png');
      background-repeat: no-repeat;
      background-size: auto;
  }
}
@media screen and (max-width: 1024px)
{
  .tabs
  {
      display: block;

      white-space: pre-wrap;
  }
  .tabs ul
  {
    padding: 0px;
    margin: 0px;
  }
  .rightNav2 .homeLnk {
      background-image: url('/static/HeadImages/leftmarine-sign-brandcolorop75s.png');
      background-repeat: no-repeat;
      background-size: auto;
  }
  .rightNav2 li {
    display: inline;
    padding-right: 6px;
    padding-left: 20px;
    color: white;
  }
  .tabs .homeLnk.is-active
  {
      background-image: url('/static/HeadImages/leftmarine-sign-brandcolors.png');
      background-repeat: no-repeat;
      background-size: auto;
  }
}
@media screen and (max-width: 550px)
{
  .tabs
  {
      display: block;
      font-size: 0.75rem;
      white-space: pre-wrap;
  }
  .tabs .homeLnk.is-active
  {
      background-image:none;
      background-repeat: no-repeat;
      background-size: auto;
  }
  .rightNav2 .homeLnk {
      background-image:none;
      background-repeat: no-repeat;
      background-size: auto;
  }
  .tabs ul
  {
    padding: 0px;
    margin: 0px;
  }
  .rightNav2 li {
    display: inline;
    padding-right: 0px;
    padding-left: 0px;
    color: white;
  }
}

</style>
<template>
<div>
    <div class="tabs">
      <ul class="rightNav2">
        <li class="homeLnk t-link" v-for="tab in tabs" :class="{ 'is-active': tab.isActive }">
            <a  @click="selectTab(tab)">{{ tab.name }}</a>
        </li>
      </ul>
    </div>
    <div class="tabs-details">
        <slot></slot>
    </div>
</div>
</template>
<script>

 export default
 {
    name: "tabs",
    data: function() {
          return {tabs: [] };

    },
    created: function() {
       this.tabs = this.$children;
    },
    methods:
    {
      selectTab(selectedTab)
      {
         this.tabs.forEach(tab => {
             tab.isActive = (tab.name == selectedTab.name);
         });
       }
    }

}

</script>
